export default __webpack_public_path__ + "static/media/tomas.3ac34bd9.jpeg";